import { ReactElement, useCallback, memo } from 'react';

import { NavigationSubListItemProps } from './types';
import {
  NavigationListItemContainer,
  NavigationListItemButton,
  NavigationListItemText,
} from './styles';

const NavigationSubListItem = ({
  item,
  isActive = false,
  onClick,
}: NavigationSubListItemProps): ReactElement => {
  const { id, label, path } = item;

  const handleClick = useCallback(() => {
    onClick?.({ id, path });
  }, [onClick, id, path]);

  return (
    <NavigationListItemContainer hasChildren={false}>
      <NavigationListItemButton onClick={handleClick} isActive={isActive}>
        <NavigationListItemText
          primary={label}
          primaryTypographyProps={{ variant: 'inherit' }}
        />
      </NavigationListItemButton>
    </NavigationListItemContainer>
  );
};

export default memo(NavigationSubListItem);
